import { render, staticRenderFns } from "./MergeStartups.vue?vue&type=template&id=f3c4fc7a&scoped=true"
import script from "./MergeStartups.vue?vue&type=script&lang=js"
export * from "./MergeStartups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c4fc7a",
  null
  
)

export default component.exports